jQuery('#CartSection #quantity-selector').each(function() {
  var spinner = jQuery(this),
      input = spinner.find('input[type="number"]'),
      btnUp = spinner.find('.quantity-up'),
      btnDown = spinner.find('.quantity-down'),
      min = input.attr('min'),
      max = input.attr('max');

  btnUp.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue >= max) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue + 1;
    }
    spinner.find("input").attr('value', newVal);
    spinner.find("input").trigger("change");
    sendForm();
  });

  btnDown.click(function() {
    var oldValue = parseFloat(input.val());
    if (oldValue <= min) {
      var newVal = oldValue;
    } else {
      var newVal = oldValue - 1;
    }
    spinner.find("input").attr('value', newVal);
    spinner.find("input").trigger("change");
    sendForm();
  });
});



function sendForm() {
	if($(window).width() < 1024) {
      //console.log("small");
      //jQuery.post('/cart.js', $('form[action="/cart"].small-form').serialize());
      
      $.ajax({
        type: 'POST',
        url: '/cart.js/',
        data: $('form[action="/cart"].small-form').serialize(),
        success: function(){
        	window.location.reload(false);
      	}
      });
      
    } else {
      //jQuery.post('/cart.js', $('form[action="/cart"].big-form').serialize());
      
      $.ajax({
        type: 'POST',
        url: '/cart.js/',
        data: $('form[action="/cart"].big-form').serialize(),
        success: function(){
        	window.location.reload(false);
      	}
      });
    }
  
}

$('#checkout-btn').on('click', function(){
  window.location.href = "/checkout";
});
